export default {"id":"icon-logo-vue"}